module.exports = __webpack_public_path__ + "static/coconut-6210834b9131c63d53a9e540b01ff083.svg";